module.exports = __webpack_public_path__ + "0435650ec4c4f95a89c59382d9f3e5c5.png";